import productCostService from '../services/productcost.service';
import PartnerService from '../services/partner.service';
import moment from 'moment'


let today = new Date();
const getDefaultState = () => {
  return {
    contract_id: "",
    delivery_voucher_id: "",
    partner_id: null,
    partner_code: "",
    cost_type: 4,
    issue_date: moment(today).format("YYYY-MM-DD"),
    category_cost: 2,
    partner_inv_no: null,
    partner_inv_date: null,
    cost_name: "",
    cost_amount: null,
    cost_tax: null,
    payment_due_date: null,
    actual_payment_date: null,
    cost_actual_amount: null,
    remark: "",
    status: 1
  }
}

export const productCostDelivery = {
    namespaced: true,
    state: {
      stateData: getDefaultState()
    },
    actions: {
      resetState({commit}) {
        commit("resetState");
      },
      getListPartner({commit}, page=1, size=-1, type=2) {
        return productCostService.getListPartner(page, size, type).then(
          (response) => {
            // commit('getListPartnerSuccess', response);
            return Promise.resolve(response);
          },
          (error) => {
            commit('getListPartnerFailure');
            return Promise.reject(error);
          }
        );
      },
      getProductCostDetailForModalByDeliveryID({commit}, id) {
        return productCostService.getProductCostDetailForModalByDeliveryID(id).then(
          (response) => {
            commit('getProductCostDetailForModalByDeliveryIDSuccess', response);
            return Promise.resolve(response);
          },
          (error) => {
            commit('getProductCostDetailForModalByDeliveryIDFailure');
            return Promise.reject(error);
          }
        );
      },
      createDeliveryProductCostModal({commit}, data) {
        return productCostService.createDeliveryProductCostModal(data).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit("createDeliveryProductCostModalFailure");
            return Promise.reject(error);
          }
        );
      },
      updateDeliveryProductCostModal({commit}, data) {
        return productCostService.updateDeliveryProductCostModal(data).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit("updateDeliveryProductCostModalFailure");
            return Promise.reject(error);
          }
        );
      },
      getPartnerInfo({commit}, id) {
        return PartnerService.getPartnerInfo(id).then(
          (response) => {
            return Promise.resolve(response);
          },
          (error) => {
            commit('getPartnerFailure');
            return Promise.reject(error);
          }
        );
      }
    },
    mutations: {
      resetState (state) {
        console.log("run resetState");
        Object.assign(state.stateData, getDefaultState());
      },
      getListPartnerSuccess(state, response) {
        state.stateData.list_partners = response.listItems
      },
      getListPartnerFailure(state) {
        state.stateData.list_partners = [];
      },
      getProductCostDetailForModalByDeliveryIDSuccess(state, response) {
        // Object.assign(state.stateData, getDefaultState());
        state.stateData = {...state.stateData, ...response};
      }
    }
}